module.exports = __webpack_public_path__ + "img/avatar-matthew-cunningham.8da190f8.jpg";